import Component from "@glimmer/component";
import { action } from "@ember/object";
import { next } from "@ember/runloop";
import { service } from "@ember/service";
import DiscourseURL from "discourse/lib/url";
import DButton from "discourse/ui-kit/d-button";

export default class ChatNavbarFullPageButton extends Component {
  @service chat;
  @service chatStateManager;

  @action
  async openInFullPage() {
    this.chatStateManager.storeAppURL();
    this.chatStateManager.prefersFullPage();
    this.chat.activeChannel = null;

    await new Promise((resolve) => next(resolve));

    DiscourseURL.routeTo(this.chatStateManager.lastKnownChatURL);
  }

  <template>
    {{#if this.chatStateManager.isDrawerExpanded}}
      <DButton
        class="btn-transparent no-text c-navbar__full-page-button"
        @action={{this.openInFullPage}}
        @icon="discourse-expand"
        @title="chat.open_full_page"
      />
    {{/if}}
  </template>
}
